export const CREATE_CHAT_ROOM = "FUND@CREATE_CHAT_ROOM";
export const CREATE_CHAT_ROOM_INIT = "FUND@CREATE_CHAT_ROOM_INIT";
export const CREATE_CHAT_ROOM_SUCCESS = "FUND@CREATE_CHAT_ROOM_SUCCESS";
export const CREATE_CHAT_ROOM_FAILED = "FUND@CREATE_CHAT_ROOM_FAILED";

export const ADD_USER_INTO_ROOM = "FUND@ADD_USER_INTO_ROOM";
export const ADD_USER_INTO_ROOM_INIT = "FUND@ADD_USER_INTO_ROOM_INIT";
export const ADD_USER_INTO_ROOM_SUCCESS = "FUND@ADD_USER_INTO_ROOM_SUCCESS";
export const ADD_USER_INTO_ROOM_FAILED = "FUND@ADD_USER_INTO_ROOM_FAILED";

export const GET_HEDGEFUND_DETAIL = "FUND@GET_HEDGEFUND_DETAIL";
export const GET_HEDGEFUND_DETAIL_INIT = "FUND@GET_HEDGEFUND_DETAIL_INIT";
export const GET_HEDGEFUND_DETAIL_SUCCESS = "FUND@GET_HEDGEFUND_DETAIL_SUCCESS";
export const GET_HEDGEFUND_DETAIL_FAILED = "FUND@GET_HEDGEFUND_DETAIL_FAILED";

export const GET_FUND_MANAGERS_ACTION = "FUND@GET_FUND_MANAGERS_ACTION";
export const GET_FUND_MANAGERS_REQUEST = "FUND@GET_FUND_MANAGERS_REQUEST";
export const GET_FUND_MANAGERS_SUCCESS = "FUND@GET_FUND_MANAGERS_SUCCESS";
export const GET_FUND_MANAGERS_FAILED = "FUND@GET_FUND_MANAGERS_FAILED";

export const GET_HEDGE_USER_FREE_SLOTS_ACTION =
  "FUND@GET_HEDGE_USER_FREE_SLOTS_ACTION";
export const GET_HEDGE_USER_FREE_SLOTS_REQUEST =
  "FUND@GET_HEDGE_USER_FREE_SLOTS_REQUEST";
export const GET_HEDGE_USER_FREE_SLOTS_SUCCESS =
  "FUND@GET_HEDGE_USER_FREE_SLOTS_SUCCESS";
export const GET_HEDGE_USER_FREE_SLOTS_FAILED =
  "FUND@GET_HEDGE_USER_FREE_SLOTS_FAILED";

export const GET_ALL_USERS_ACTION = "FUND@GET_ALL_USERS_ACTION";
export const GET_ALL_USERS_REQUEST = "FUND@GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = "FUND@GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILED = "FUND@GET_ALL_USERS_FAILED";

export const CREATE_APPOINTMENT_ACTION = "FUND@CREATE_APPOINTMENT_ACTION";
export const CREATE_APPOINTMENT_REQUEST = "FUND@CREATE_APPOINTMENT_REQUEST";
export const CREATE_APPOINTMENT_SUCCESS = "FUND@CREATE_APPOINTMENT_SUCCESS";
export const CREATE_APPOINTMENT_FAILED = "FUND@CREATE_APPOINTMENT_FAILED";

export const INVEST_IN_FUND = "FUND@INVEST_IN_FUND";
export const INVEST_IN_FUND_REQUEST = "FUND@INVEST_IN_FUND_REQUEST";
export const INVEST_IN_FUND_SUCCESS = "FUND@INVEST_IN_FUND_SUCCESS";
export const INVEST_IN_FUND_FAILED = "FUND@INVEST_IN_FUND_FAILED";

export const CREATE_NOTES = "FUND@CREATE_NOTES";
export const CREATE_NOTES_INIT = "FUND@CREATE_NOTES_INIT";
export const CREATE_NOTES_SUCCESS = "FUND@CREATE_NOTES_SUCCESS";
export const CREATE_NOTES_FAILED = "FUND@CREATE_NOTES_FAILED";

export const GET_NOTES = "FUND@GET_NOTES";
export const GET_NOTES_INIT = "FUND@GET_NOTES_INIT";
export const GET_NOTES_SUCCESS = "FUND@GET_NOTES_SUCCESS";
export const GET_NOTES_FAILED = "FUND@GET_NOTES_FAILED";

export const SEARCH_PMRESULT = "FUND@SEARCH_PMRESULT";
export const SEARCH_PMRESULT_INIT = "FUND@SEARCH_PMRESULT_INIT";
export const SEARCH_PMRESULT_SUCCESS = "FUND@SEARCH_PMRESULT_SUCCESS";
export const SEARCH_PMRESULT_FAILED = "FUND@SEARCH_PMRESULT_FAILED";

export const SEARCH_RPRESULT = "FUND@SEARCH_RPRESULT";
export const SEARCH_RPRESULT_INIT = "FUND@SEARCH_RPRESULT_INIT";
export const SEARCH_RPRESULT_SUCCESS = "FUND@SEARCH_RPRESULT_SUCCESS";
export const SEARCH_RPRESULT_FAILED = "FUND@SEARCH_RPRESULT_FAILED";

export const SEARCH_REPORTRESULT = "FUND@SEARCH_REPORTRESULT";
export const SEARCH_REPORTRESULT_INIT = "FUND@SEARCH_REPORTRESULT_INIT";
export const SEARCH_REPORTRESULT_SUCCESS = "FUND@SEARCH_REPORTRESULT_SUCCESS";
export const SEARCH_REPORTRESULT_FAILED = "FUND@SEARCH_REPORTRESULT_FAILED";

export const CREATE_AUDITLOGS = "FUND@CREATE_AUDITLOGS";
export const CREATE_AUDITLOGS_INIT = "FUND@CREATE_AUDITLOGS_INIT";
export const CREATE_AUDITLOGS_SUCCESS = "FUND@CREATE_AUDITLOGS_SUCCESS";
export const CREATE_AUDITLOGS_FAILED = "FUND@CREATE_AUDITLOGS_FAILED";

export const GET_ALL_ADMIN_LIST = "TENANT@GET_ALL_ADMIN_LIST";
export const GET_ALL_ADMIN_LIST_INIT = "TENANT@GET_ALL_ADMIN_LIST_INIT";
export const GET_ALL_ADMIN_LIST_SUCCESS = "TENANT@GET_ALL_ADMIN_LIST_SUCCESS";
export const GET_ALL_ADMIN_LIST_FAILED = "TENANT@GET_ALL_ADMIN_LIST_FAILED";

export const GET_ALLOCATOR_USERS = "FUND@GET_ALLOCATOR_USERS";
export const GET_ALLOCATOR_USERS_INIT = "FUND@GET_ALLOCATOR_USERS_INIT";
export const GET_ALLOCATOR_USERS_SUCCESS = "FUND@GET_ALLOCATOR_USERS_SUCCESS";
export const GET_ALLOCATOR_USERS_FAILED = "FUND@GET_ALLOCATOR_USERS_FAILED";

export const GET_FUND_DETAILS = "FUND@GET_FUND_DETAILS";
export const GET_FUND_DETAILS_INIT = "FUND@GET_FUND_DETAILS_INIT";
export const GET_FUND_DETAILS_SUCCESS = "FUND@GET_FUND_DETAILS_SUCCESS";
export const GET_FUND_DETAILS_FAILED = "FUND@GET_FUND_DETAILS_FAILED";

export const GET_FUND_BIO_USER = "FUND@GET_FUND_BIO_USER";
export const GET_FUND_BIO_USER_INIT = "FUND@GET_FUND_BIO_USER_INIT";
export const GET_FUND_BIO_USER_SUCCESS = "FUND@GET_FUND_BIO_USER_SUCCESS";
export const GET_FUND_BIO_USER_FAILED = "FUND@GET_FUND_BIO_USER_FAILED";
